import React, {useEffect}  from "react"
import {useSearchParams, useNavigate} from 'react-router-dom';
import TouchpointSelection from "components/SelfCheckin/TouchpointSelection/TouchpointSelection"
import useSelfCheckinNafigation from 'utils/useSelfCheckinNafigation';

import Passenger from "components/SelfCheckin/Passenger/Passenger"
import ScanBoardingPass from "components/SelfBoarding/ScanBoardingPass/ScanBoardingPass"
import PassengerNotFound from "components/SelfBoarding/PassengerNotFound/PassengerNotFound"

import { SelfBoardingStepEnum } from "components/shared/enums/global-enums.tsx";
import useStore from 'store/store'
import {AppRoutes} from "utils/routes";
import './SelfBoarding.scss'

export default function SelfBoarding(){

  const navigate = useNavigate();
  let [searchParams, ] = useSearchParams();
  // let airline = searchParams.get("airline");

  let resetTouchpoint = searchParams.get("resetTouchpoint");

  const storeActions = useStore((state)=> state.actions);
  let activeStep = searchParams.get("activeStep");
  const [redirect, ] = useSelfCheckinNafigation();

  const touchpoint = storeActions.retrieveItem("touchpoint");

  useEffect(()=>{
    // 1 hour
    let TIMEOUT = 1000*60*60;
    if (activeStep !== SelfBoardingStepEnum.SCAN_BOARDING_PASS){
      TIMEOUT = 4000;
    }
    
    storeActions.startTimeout(()=>{redirect(-1, SelfBoardingStepEnum.SCAN_BOARDING_PASS)}, TIMEOUT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeActions, activeStep]);

  useEffect(()=>{
    if (resetTouchpoint) {
      storeActions.storeItem("touchpoint", null);
      navigate(AppRoutes.selfCheckinPath);
    }

  }, [storeActions, resetTouchpoint, navigate]);

  function goToScanBoardingPass() {
    redirect(-1, SelfBoardingStepEnum.SCAN_BOARDING_PASS);
  }


  let step;

  if(!activeStep || activeStep === SelfBoardingStepEnum.SCAN_BOARDING_PASS){
    step = <ScanBoardingPass  navigate={navigate}  airline={"boarding"} />;

  }else if(activeStep === SelfBoardingStepEnum.PASSENGER_BOARDING){
    step = <div onClick={goToScanBoardingPass}><Passenger airline={"sita"} typeFor={SelfBoardingStepEnum.PASSENGER_BOARDING}/></div>;

  }else if(activeStep === SelfBoardingStepEnum.PASSENGER_NOT_FOUND){
    step = <div onClick={goToScanBoardingPass}><PassengerNotFound airline={"boarding"} /></div>;
  }


  return (
    <div className="self-checkin">

      {
        !touchpoint ? (<TouchpointSelection/> ): (step)
      }
      
    </div>
    )
}